import { User } from "firebase/auth";

export const useAuthUser = defineStore("auth/user", () => {
  const currentUser = ref<User | undefined | null>(undefined);

  const getUser = async () => {
    return new Promise(async (resolve, reject) => {
      if (currentUser.value != undefined) {
        resolve(currentUser.value);
        return;
      }

      const user = await getCurrentUser();

      currentUser.value = user;

      resolve(user);
    });
  };

  const setUser = (user: User | undefined | null) => {
    currentUser.value = user;
  };

  return {
    getUser,
    setUser,
  };
});
